import React from "react";

const Pdf = (props) => {
  return (
    <div className="centralized">
      <embed
        src={`data:application/pdf;base64,${props.location.state.pdf}`}
        type="application/pdf"
        width="800"
        height="980"
      ></embed>
    </div>
  );
};

export default Pdf;
